import { gql } from '@apollo/client';

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation UpdateNotificationSettings($emailEnabled: Boolean, $pushEnabled: Boolean, $marketingEnabled: Boolean) {
    updateNotificationSettings(input: { emailEnabled: $emailEnabled, pushEnabled: $pushEnabled, marketingEnabled: $marketingEnabled }) {
      notificationSetting {
        emailEnabled
        pushEnabled
        marketingEnabled
      }
      errors
    }
  }
`;
